import React from "react";
import { getFullName } from "../../../careprovider/visits/utils";
import { RoleToLinkMapper } from "../../../utils/UrlUtils";
import { useGetRole } from "../../../generic/hooks/useGetRole";
import { useNavigate } from "react-router";
import { Typography } from "antd";

const CoordinatorCard = ({ coordinator }) => {
  const role = useGetRole();
  const navigate = useNavigate();

  const handleNavigation = () => {
    if (role === "Volunteer Coordinator") {
      navigate(
        `${RoleToLinkMapper(role)}cooordinator-profile?identifier=${
          coordinator?.userIdentifier
        }`,
      );
      window.scrollTo(0, 0);
    }
  };

  return (
    <>
      <div>
        By:{" "}
        <Typography className="cursor-pointer" onClick={handleNavigation} style={{ display: "inline" }}>
          {getFullName(coordinator?.givenName, coordinator?.familyName)}
        </Typography>
      </div>
    </>
  );
};

export default CoordinatorCard;
